import {
  InquiryStatusMetadata,
  InquiryStatusMetadataArgs,
  getInquiryStatusMetadata,
} from '../../assets/ts/data/inquiry/inquiry-status-metadata'
import useServerData from '../use-server-data'

function useInquiryStatusMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: inquiryStatusMetadata,
    error: inquiryStatusMetadataError,
    fetchData: fetchInquiryStatusMetdata,
    isLoading: inquiryStatusMetadataIsLoading,
  } = useServerData<InquiryStatusMetadata, InquiryStatusMetadataArgs>(
    getInquiryStatusMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  
  return {
    fetchInquiryStatusMetdata,
    inquiryStatusMetadata,
    inquiryStatusMetadataError,
    inquiryStatusMetadataIsLoading,
  }
}

export default useInquiryStatusMetadata
